import {
  AI_ICON_COMPONENTS,
  resolveAiIconKey,
} from '@caddie/ui-kit/components/icons';
import { ANIMATED_AI_ICONS, iconSlotSizeClasses } from './constants/ai-icons';
import type { SuperBarViewState } from './context/use-chat-context';
import { LoadingAnimation } from './LoadingAnimation';
import { cn } from './utils/styles';

interface AiIconDisplayProps {
  icon: unknown;
  state: 'stable' | 'loading';
  superBarViewState: SuperBarViewState;
}

// Renders the merchant's selected AI icon: the animated orb for icons with a
// CDN animation (icon5 today), otherwise the static icon component.
export const AiIconDisplay = ({
  icon,
  state,
  superBarViewState,
}: AiIconDisplayProps) => {
  const iconKey = resolveAiIconKey(typeof icon === 'string' ? icon : undefined);

  if (ANIMATED_AI_ICONS.has(iconKey)) {
    return (
      <LoadingAnimation state={state} superBarViewState={superBarViewState} />
    );
  }

  const IconComponent = AI_ICON_COMPONENTS[iconKey];
  return (
    <div
      data-ai-icon={iconKey}
      className={cn(
        'caddietw-flex caddietw-items-center caddietw-justify-center caddietw-rounded-full caddietw-overflow-hidden',
        iconSlotSizeClasses(superBarViewState)
      )}
    >
      <IconComponent className="caddietw-w-full caddietw-h-full" />
    </div>
  );
};
